import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useOrders } from "@/lib/OrdersContext";

export const Notifications = () => {
  const { orders, notifications, setNotifications } = useOrders();
  const ready = orders.filter((o) => o.estado === "listo_entregar");
  const unpaidReady = ready.filter((o) => !o.pagado);
  const alerts = [
    ...unpaidReady.map((o) => ({ id: `u-${o.id}`, text: `${o.matricula} listo con pago pendiente` })),
    ...notifications,
  ];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notifications-btn" className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-white/10 bg-white/[0.03] text-zinc-300 transition-colors hover:text-[var(--gold)]">
          <Bell className="h-[18px] w-[18px]" />
          {alerts.length > 0 && (
            <span data-testid="notifications-count" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--gold)] px-1 text-[10px] font-bold text-black">
              {alerts.length}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 border-white/10 bg-[#111114] p-0" data-testid="notifications-panel">
        <div className="flex items-center justify-between border-b border-white/5 px-4 py-3">
          <p className="font-display text-sm font-semibold">Notificaciones</p>
          <button data-testid="notifications-clear-btn" onClick={() => setNotifications([])} className="text-xs text-zinc-500 hover:text-[var(--gold)]">Limpiar</button>
        </div>
        <div className="scroll-thin max-h-80 overflow-y-auto">
          {alerts.length === 0 && <p className="px-4 py-6 text-center text-sm text-zinc-500">Sin novedades</p>}
          {alerts.map((a) => (
            <div key={a.id} className="border-b border-white/5 px-4 py-3 text-sm text-zinc-300">{a.text}</div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
